import { render, staticRenderFns } from "./Area_fixedbg.vue?vue&type=template&id=39fc2b30&scoped=true&"
import script from "./Area_fixedbg.vue?vue&type=script&lang=js&"
export * from "./Area_fixedbg.vue?vue&type=script&lang=js&"
import style0 from "./Area_fixedbg.vue?vue&type=style&index=0&id=39fc2b30&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39fc2b30",
  null
  
)

export default component.exports